import moment from "moment";
import "moment/locale/es";
import { HeaderEmpresaCard } from "../Components/PdfComponents/HeaderEmpresaCard";

moment.locale("es");

const getEstadoTexto = (estadoNum) => {
  switch (estadoNum) {
    case 1:
      return "Activo";
    default:
      return "Inactivo";
  }
};

const reporteRegistroEmpleadosPdf = (values) => {
  const empresa = values.empresa;
  const logoBiwo = values.logoBiwo;
  let filtrados = [];

  if (values.departamentos && values.departamentos.length > 0) {
    let textoFiltrado = "";
    values.departamentos.map((valueDepartamento) => {
      textoFiltrado += `${valueDepartamento.nombre}\n`;
      return null;
    });
    filtrados.push([
      { text: "Departamentos:", style: "subheader" },
      { text: textoFiltrado, style: "textoChico" },
    ]);
  }

  if (values.relojesChecadores && values.relojesChecadores.length > 0) {
    let textoFiltrado = "";
    values.relojesChecadores.map((valueReloj) => {
      textoFiltrado += `${valueReloj.stringBuscar || valueReloj.nombre}\n`;
      return null;
    });
    filtrados.push([
      { text: "Relojes Checadores:", style: "subheader" },
      { text: textoFiltrado, style: "textoChico" },
    ]);
  }

  if (values.estado !== 3) {
    filtrados.push([
      { text: "Estado:", style: "subheader" },
      { text: getEstadoTexto(values.estado), style: "textoChico" },
    ]);
  }

  if (filtrados.length === 0) {
    filtrados.push([
      { text: "No tiene filtrados adicionales", style: "subheader" },
      { text: "", style: "textoChico" },
    ]);
  }

  const tableHeaders = [
    { text: "Numero", style: "tituloTabla" },
    { text: "Empleado", style: "tituloTabla" },
    { text: "Departamento", style: "tituloTabla" },
    { text: "Reloj Checador", style: "tituloTabla" },
    { text: "Ubicacion", style: "tituloTabla" },
    { text: "Usuario/PIN", style: "tituloTabla" },
    { text: "Fecha Alta", style: "tituloTabla" },
    { text: "Estado", style: "tituloTabla" },
  ];
  const tableWidths = ["7%", "20%", "14%", "17%", "16%", "10%", "9%", "7%"];

  let filas = [];
  for (const empleado of values.empleados || []) {
    const registros = empleado.registros && empleado.registros.length > 0
      ? empleado.registros
      : [null];

    registros.forEach((registro, index) => {
      filas.push([
        { text: index === 0 ? (empleado.serieNumero || "N/A") : "", style: "textoTabla", alignment: "left" },
        { text: index === 0 ? (empleado.nombre || "N/A") : "", style: "textoTabla", alignment: "left" },
        { text: index === 0 ? (empleado.departamento || "N/A") : "", style: "textoTabla", alignment: "left" },
        { text: registro ? (registro.relojChecadorNombre || "N/A") : "Sin registros", style: "textoTabla", alignment: "left" },
        { text: registro ? (registro.ubicacion || "N/A") : "", style: "textoTabla", alignment: "left" },
        { text: registro ? (registro.usuarioRelojChecador || "N/A") : "", style: "textoTabla", alignment: "center" },
        {
          text: registro && registro.fechaAlta ? moment(registro.fechaAlta).format("DD/MM/YYYY") : "",
          style: "textoTabla",
          alignment: "center",
        },
        { text: registro ? getEstadoTexto(registro.estadoAsignacion) : "", style: "textoTabla", alignment: "left" },
      ]);
    });
  }

  const rostrosHeaders = [
    { text: "Numero", style: "tituloTabla" },
    { text: "Empleado", style: "tituloTabla" },
    { text: "Reloj Checador", style: "tituloTabla" },
    { text: "No. Plantilla", style: "tituloTabla" },
    { text: "Capturado", style: "tituloTabla" },
  ];
  const rostrosWidths = ["10%", "30%", "30%", "15%", "15%"];
  let filasRostros = [];
  for (const empleado of values.empleados || []) {
    const rostros = empleado.biometria?.rostros || [];
    rostros.forEach((rostro, index) => {
      filasRostros.push([
        { text: index === 0 ? (empleado.serieNumero || "N/A") : "", style: "textoTabla", alignment: "left" },
        { text: index === 0 ? (empleado.nombre || "N/A") : "", style: "textoTabla", alignment: "left" },
        { text: rostro.relojChecadorNombre || "N/A", style: "textoTabla", alignment: "left" },
        { text: `${rostro.no ?? "N/A"}${rostro.legacy ? " (legacy)" : ""}`, style: "textoTabla", alignment: "center" },
        {
          text: rostro.capturadoAt ? moment(rostro.capturadoAt).format("DD/MM/YYYY HH:mm") : "N/A",
          style: "textoTabla",
          alignment: "center",
        },
      ]);
    });
  }

  const huellasHeaders = [
    { text: "Numero", style: "tituloTabla" },
    { text: "Empleado", style: "tituloTabla" },
    { text: "Reloj Checador", style: "tituloTabla" },
    { text: "Dedo", style: "tituloTabla" },
    { text: "Capturado", style: "tituloTabla" },
  ];
  const huellasWidths = ["10%", "30%", "30%", "15%", "15%"];
  let filasHuellas = [];
  for (const empleado of values.empleados || []) {
    const huellas = empleado.biometria?.huellas || [];
    huellas.forEach((huella, index) => {
      filasHuellas.push([
        { text: index === 0 ? (empleado.serieNumero || "N/A") : "", style: "textoTabla", alignment: "left" },
        { text: index === 0 ? (empleado.nombre || "N/A") : "", style: "textoTabla", alignment: "left" },
        { text: huella.relojChecadorNombre || "N/A", style: "textoTabla", alignment: "left" },
        { text: `${huella.fid ?? "N/A"}`, style: "textoTabla", alignment: "center" },
        {
          text: huella.capturadoAt ? moment(huella.capturadoAt).format("DD/MM/YYYY HH:mm") : "N/A",
          style: "textoTabla",
          alignment: "center",
        },
      ]);
    });
  }

  const layoutTablaLineas = {
    fillColor: (rowIndex) => (rowIndex === 0 ? "#cccccc" : rowIndex % 2 === 0 ? "#e8e8e8" : "#ffffff"),
    hLineWidth: function (i, node) { return 1; },
    vLineWidth: function (i, node) { return 1; },
    hLineColor: function (i, node) { return "#adaaaa"; },
    vLineColor: function (i, node) { return "#adaaaa"; },
    hLineStyle: function (i, node) {
      if (i === 0 || i === node.table.body.length) { return null; }
      return { dash: { length: 2, space: 1 } };
    },
    vLineStyle: function (i, node) {
      if (i === 0 || i === node.table.widths.length) { return null; }
      return { dash: { length: 2 } };
    },
  };

  var dd = {
    footer: {
      image: "logoBiwo",
      alignment: "center",
      width: 80,
    },
    content: [
      {
        style: "tableExample",
        table: {
          widths: ["18%", "52%", "30%"],
          layout: {
            defaultBorder: false,
          },
          body: [
            [
              ...HeaderEmpresaCard(empresa, false, false,
              {
                border: [false, false, false, false],
                table: {
                  headerRows: 1,
                  widths: ["100%"],
                  body: [
                    [{ text: "Fecha de Impresion:", style: "subheader", alignment: "center" }],
                    [{ text: moment().locale("es").format("LL"), style: "textoChico", alignment: "center" }],
                  ],
                },
                layout: "noBorders",
              }),
            ],
          ],
        },
      },
      {
        text: "Registro de Empleados en Reloj Checador",
        style: "tableHeaderIzquierda",
      },
      { text: "Datos de filtrado:" },
      {
        style: "tableExample",
        table: {
          widths: ["20%", "80%"],
          body: filtrados,
        },
        layout: {
          hLineWidth: function (i, node) { return 1; },
          vLineWidth: function (i, node) { return 1; },
          hLineColor: function (i, node) { return "#adaaaa"; },
          vLineColor: function (i, node) { return "#adaaaa"; },
          hLineStyle: function (i, node) {
            if (i === 0 || i === node.table.body.length) { return null; }
            return { dash: { length: 2, space: 1 } };
          },
          vLineStyle: function (i, node) {
            if (i === 0 || i === node.table.widths.length) { return null; }
            return { dash: { length: 2 } };
          },
        },
      },
      {
        style: "tableExample",
        table: {
          widths: tableWidths,
          layout: {
            defaultBorder: true,
          },
          body: [
            tableHeaders,
            ...filas,
          ],
        },
        layout: {
          fillColor: (rowIndex, node, columnIndex) => {
            if (rowIndex === 0) {
              return "#cccccc";
            }
            return rowIndex % 2 === 0 ? "#e8e8e8" : "#ffffff";
          },
          hLineWidth: function (i, node) { return 1; },
          vLineWidth: function (i, node) { return 1; },
          hLineColor: function (i, node) { return "#adaaaa"; },
          vLineColor: function (i, node) { return "#adaaaa"; },
          hLineStyle: function (i, node) {
            if (i === 0 || i === node.table.body.length) { return null; }
            return { dash: { length: 2, space: 1 } };
          },
          vLineStyle: function (i, node) {
            if (i === 0 || i === node.table.widths.length) { return null; }
            return { dash: { length: 2 } };
          },
        },
      },
      {
        text: "Registro Biometrico - Rostros",
        style: "tableHeaderIzquierda",
        margin: [0, 15, 0, 0],
      },
      filasRostros.length > 0
        ? {
            style: "tableExample",
            table: { widths: rostrosWidths, layout: { defaultBorder: true }, body: [rostrosHeaders, ...filasRostros] },
            layout: layoutTablaLineas,
          }
        : { text: "Sin rostros registrados", style: "textoChico", margin: [0, 5, 0, 0] },
      {
        text: "Registro Biometrico - Huellas",
        style: "tableHeaderIzquierda",
        margin: [0, 15, 0, 0],
      },
      filasHuellas.length > 0
        ? {
            style: "tableExample",
            table: { widths: huellasWidths, layout: { defaultBorder: true }, body: [huellasHeaders, ...filasHuellas] },
            layout: layoutTablaLineas,
          }
        : { text: "Sin huellas registradas", style: "textoChico", margin: [0, 5, 0, 0] },
    ],
    images: {
      logo: empresa.logo.base64Completa,
      logoBiwo: logoBiwo.base64Completa,
    },
    styles: {
      tableHeaderIzquierda: { bold: true, fontSize: 18, color: "black" },
      header: {
        fontSize: 9,
        bold: true,
      },
      subheader: {
        fontSize: 8,
        bold: true,
      },
      tableExample: {
        margin: [0, 5, 0, 5],
      },
      textoChico: {
        fontSize: 8,
      },
      tituloTabla: {
        fontSize: 8,
        bold: true,
        fillColor: "#cccccc",
        style: "subheader",
        alignment: "center",
        border: true,
      },
      textoTabla: {
        fontSize: 8,
        italics: false,
      },
    },
    pageSize: "LETTER",
    pageMargins: [20, 20, 20, 60],
  };
  return dd;
};

export default reporteRegistroEmpleadosPdf;
